import { useTranslation } from "react-i18next";

import { Button, Column, Columns, Typography } from "@aviary";
import { useBreakpoints } from "@shared/hooks";
import { headerProductLinks } from "@unauthenticated/catalog/data/CatalogMenuLinks";
import { openCatalogRoutes } from "@unauthenticated/catalog/data/openCatalogRoutes";
import { l } from "@unauthenticated/catalog/locales/i18n";

import { DescriptionIconAndLink } from "../../../DescriptionIconAndLink";
import * as styles from "../MenuItems.styles";

const Product = () => {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();
  const isMobile = tablet.lessThan;

  return (
    <Columns>
      <Column columnWidth={6} css={isMobile && styles.mobileContent}>
        <div css={styles.softwareBlurb}>
          <a href={openCatalogRoutes.howItWorks} css={styles.mainLink}>
            <Typography type="h1" sizeOverride="h3">
              <span>{t(l.navigation.MenuItems.PractitionerSoftware)}</span>
            </Typography>
            <Typography type="body">{t(l.navigation.MenuItems.ProductBody)}</Typography>

            <Button isOutlined css={[isMobile && styles.mobileButton, styles.button]}>
              {t(l.navigation.MenuItems.LearnMore)}
            </Button>
          </a>
        </div>
      </Column>
      <Column columnWidth={6}>
        {headerProductLinks.map(item => (
          <DescriptionIconAndLink
            key={item.key}
            title={t(item.title)}
            description={t(item.description)}
            icon={item.icon}
            link={item.link}
          />
        ))}
      </Column>
    </Columns>
  );
};

export { Product };
